<div class="container navigation" [class.visible]="navigationVisible$ | async">
  <div class="progress" [style.width]="(navigationPercent$ | async) + '%'"></div>
</div>
<div class="container fetching" [class.visible]="fetchingVisible$ | async">
  <div class="progress" [style.width]="(fetchingPercent$ | async) + '%'"></div>
</div>
